import { Injectable } from "@angular/core";
import { BehaviorSubject, first, firstValueFrom, Observable, Subject, Subscription, take } from "rxjs";
import * as Sentry from '@sentry/angular';
import { IGeoPosDataLocation } from "../../route-section/models/IDataLocation";
import { LocationDTO } from "../models/LocationDTO";
import { DataNamesDTO } from "../models/DataNamesDTO";
import { LocationsService } from "./Locations.service";
import { CitronellaActionsService } from "../../../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { CreateEmptyLocationDTO } from "../../../../shared/helpers/DTO/CreateEmptyLocationDTO";
import { ValetParkingService } from "./ValetParking.service";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { RouteFilterService } from "../../route-section/services/Route-Filter.service";
import { ValetParkingMapComponent } from "../components/3-panel-detail-locations/organisms/valet-parking-map/valet-parking-map.component";
import { ValetParkingMapService } from "./ValetParkingMap.service";
import { environment } from "src/environments/environment";
import { AllowedDTO } from "src/app/features/pages/maps/utils/models/allowedDTO";

@Injectable({
  providedIn: "root",
})
export class PanelDetailLocationsService {
  private locationDTO: LocationDTO = CreateEmptyLocationDTO();
  
  private keys: string[] = [];
  private values: string[] = [];
  private address$: Subject<string> = new Subject<string>();
  
  private keys$: Subject<string[]> = new Subject<string[]>();
  private keyNames$: Subject<DataNamesDTO[]> = new Subject<DataNamesDTO[]>();
  private dates$: Subject<string[]> = new Subject<string[]>();
  private values$: Subject<string[]> = new Subject<string[]>();
  private locationDTO$: Subject<any> = new Subject<any>();
  private allowedBloking$: Subject<boolean> = new Subject<boolean>();
  private blokingIcon$: Subject<boolean> = new Subject<boolean>();
  private Odometer$: Subject<any> = new Subject<any>();
  private Images$: Subject<string[]> = new Subject<string[]>();
  private Coords$: Subject<any> = new Subject<any>();

  public isVisible = false;

  isVisibleDetails$: Subject<boolean> = new Subject<boolean>();
  categoryDetailsSelected$: Subject<number> = new Subject<number>();
  canClosePanel$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  order: any[];
  dataType: any[];
  private isLoading$: Subject<boolean> = new Subject();
  IconGPS: string;
  configUrl: string;
  public ResultadoGPS: string;
  suscription_getDataKeyNames: Subscription;
  suscription_getLastOdometer: Subscription;

  constructor(private locationService: LocationsService,
            private routeFilterService: RouteFilterService,
            private valetParkingMapService: ValetParkingMapService,
            private citronellaActionsService: CitronellaActionsService
  ) {
  }

  setCoords(resp) {
    this.Coords$.next(resp);
  }

  getCoords(): Observable<string> {
    return this.Coords$.asObservable();
  }
  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

 
  getKeys(): Observable<string[]> {
    return this.keys$.asObservable();
  }
  setOdometer(val: any) {
    return this.Odometer$.next(val);
  }
  getOdometer(): Observable<any> {
    return this.Odometer$.asObservable();
  }
  getKeyNames(): Observable<DataNamesDTO[]> {
    return this.keyNames$.asObservable();
  }
  // setKeyNames(val: any[]) {
  //   return this.keyNames$.next(val);
  // }
  getValues(): Observable<string[]> {
    return this.values$.asObservable();
  }
  setTime(startTime: string, endTime: string) {
    this.dates$.next([startTime, endTime]);
  }
  getTime() {
    return this.dates$.asObservable();
  }

  setAddress(address: string) {
    this.address$.next(address);
  }
  getAddress() {
    return this.address$.asObservable();
  }

  setImages(val: string[]) {
    return this.Images$.next(val);
  }
  getImages(): Observable<string[]> {
    return this.Images$.asObservable();
  }

  async setData(properties: any) {
    if (properties == null || properties == undefined)
      return;
    if(!environment.production) console.log("SETDATA");
    var arrayMaster = Object.entries(properties);
    this.dataType = [];
    this.order = [];
    this.keys = [];
    this.values = [];
    arrayMaster.forEach((element) => {
      if(!environment.production) console.log(element[1]);
      var obe: IGeoPosDataLocation;
      obe = JSON.parse(JSON.stringify(element[1]));
      this.keys.push(obe.key);
      this.values.push(obe.value);
    });
    this.values$.next(this.values);
    this.keys$.next(this.keys);
    this.SetKeyNames(this.keys);

    // await this.SetImagesData(this.locationDTO.idLocationCategory,this.locationDTO.identifier);
  }

  setGeneralData(properties: any) {
    
    this.locationDTO.identifier = properties.identifier;
    this.locationDTO.description = properties.description;
    this.locationDTO.lastVoltaje = properties.lastVoltage;
    this.locationDTO.batteryPercent = properties.batteryPercent;
    this.locationDTO.gpsStatus = properties.lastGPSStatus;
    this.locationDTO.canLock = properties.canLock;
    this.locationDTO.subGroup = properties.subGroup;
    this.locationDTO.group = properties.group;
    this.locationDTO.lastUpdate = (properties.lastUpdate == '0001-01-01T00:00:00' || properties.lastUpdate == null) ? 'No disponible' : properties.lastUpdate;
    this.locationDTO.activeType = properties.Tipo;
    this.locationDTO.id = properties.id;
    this.locationDTO.statusVehiculo = properties.statusVehiculo;
    this.locationDTO.idLocationCategory = properties.idLocationCategory;
    this.locationDTO.locationCategory = properties.locationCategory;
    this.locationDTO.icon = properties.icon;
    this.locationDTO.activeIcon = properties.activeIcon;
    this.locationDTO.cordsY = properties.cordsY;
    this.locationDTO.cordsX = properties.cordsX;
    this.locationDTO.alias = properties.alias;
    this.locationDTO.categoryStatus = properties.categoryStatus;
    this.locationDTO.idLocationCategoryStatus = properties.idLocationCategoryStatus;
    this.locationDTO.panelIcon = properties.icon;
    
    this.locationDTO.responsable = properties.responsable;
    this.locationDTO.responsableDistance = properties.responsableDistance;

    this.locationDTO$.next(this.locationDTO);

    //manda las cordenadas al servicio de valet parking
    this.valetParkingMapService.coordsValetParking = { lat: parseFloat(properties.cordsY), lng: parseFloat(properties.cordsX) };

    this.setLoading(false);
  }

  getGeneralData(): Observable<any> {
    return this.locationDTO$.asObservable();
  }

  SetOdometerData(identifier: string) {
    var odometroInicialIndex = this.keys.indexOf("Odometro_Inicial");
    if(!environment.production) console.log("odometro inicial index", odometroInicialIndex, this.values);

    //CONSULTA DEL ULTIMO ODOMETRO DEL GPS
    this.suscription_getLastOdometer = this.locationService.getLastOdometer(identifier).subscribe({
      next: (data) => {

        if(data == null || data.result == null){
          if(!environment.production) console.log("No se obtuvo el último odómetro del GPS, se asignará 0km");
          data = { result: "0km" };
        }

        var lastOdometroGPS = data.result;

        if (odometroInicialIndex != -1 && this.values[odometroInicialIndex] != null) {
          var odometroInicialLocationNumero = parseFloat(
            this.values[odometroInicialIndex].replace("km", "")
          );
        } else {
          var odometroInicialLocationNumero = 0;
        }

        if (lastOdometroGPS == null) {
          lastOdometroGPS = "0km";
        }

        var lastOdometroGPSNumero = parseFloat(lastOdometroGPS.replace("km", ""));
        var odometroFinalLocation =
          odometroInicialLocationNumero + lastOdometroGPSNumero;

        var valoresOdometro = {
          odometroFinalLocation: odometroFinalLocation,
          odometroInicialLocationNumero: odometroInicialLocationNumero,
          lastOdometroGPSNumero: lastOdometroGPSNumero,
        };

        this.setOdometer(valoresOdometro);
        this.suscription_getLastOdometer.unsubscribe();
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener ultimo odómetro', error);
        this.suscription_getLastOdometer.unsubscribe();
      }
    });
  }

  async SetImagesData(idLocationCategory: number,identifier: string, isExternalImage: boolean = true) {
    if (isExternalImage) {
      try {
        var images = await this.citronellaActionsService.GetExternalImages(idLocationCategory, identifier);
        if (!!images && images.length > 0) {
          this.setImages(images);
        }else{
          this.setImages([]);
        }
      } catch (error) {
        console.error("Error fetching external images:", error);
        this.setImages([]);
      }
    }else{
      // this.citronellaActionsService.getLocationImages(identifier).subscribe((data) => {
      //   if (data.isSuccess) {
      //     this.setImages(data.result);
      //   } else {
      //     this.setImages([]);
      //   }
      // });
    }
  }

  SetKeyNames(keysArrays: any) {
    //Obtiene desde la base los nombres usables y las imagenes de las llaves existentes
    this.suscription_getDataKeyNames = this.locationService
      .getDataNames(keysArrays)
      .subscribe({
        next: (data) => {
          //Verifica si el array no es nulo, si sí, no se usa, para evitar desfases
          if (data.result != null) {
            this.keyNames$.next(data.result);
          }
          this.suscription_getDataKeyNames.unsubscribe();
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al obtener nombres de llaves de datalocations', error);
          this.suscription_getDataKeyNames.unsubscribe();
        }
      });
  }

  setDataLast(properties: any[]) {
    if(!environment.production) console.log("SETDATALAST");
    var arrayMaster = Object.entries(properties);
    var row: any;
    this.keys = [];
    this.values = [];
    arrayMaster.forEach((element) => {
      if(!environment.production) console.log(element);
      var array = element.slice();
      var iterator = array.values();
      this.keys.push(iterator.next().value.toString());
      this.values.push(iterator.next().value.toString());
    });

    this.values$.next(this.values);
    this.keys$.next(this.keys);
  }

  setBlokingIcon(locked: boolean) {
    this.blokingIcon$.next(locked);
  }

  getBlokingIcon(): Observable<boolean> {
    return this.blokingIcon$.asObservable();
  }

  setAllowedBloking(allowed: boolean) {
    this.allowedBloking$.next(allowed);
  }

  getAllowedBloking(): Observable<boolean> {
    return this.allowedBloking$.asObservable();
  }

  checkVisibilityPopup(): Observable<boolean> {
    return this.isVisibleDetails$.asObservable();
  }
  setVisibilityPopup(op) {
    this.isVisible = op;
    this.isVisibleDetails$.next(op);

    if (op == false) {
      this.setCategorySelected(-1);
    }
  }

  getCategorySelected(): Observable<number> {
    return this.categoryDetailsSelected$.asObservable();
  }
  setCategorySelected(op: number) {
    this.categoryDetailsSelected$.next(op);
  }

  setInformation(data, title, date) {}

  ButtonGPS() {
    if(!environment.production) console.log("Array", this.values);
    let valor = this.keys.findIndex((p) => p == "Estatus");

    for (var i = 0; this.values.length; i++) {
      if (i == valor) {
        let dato = this.values[i];
        let valor = "lock_open";
        this.IconGPS = valor;
      } else {
        if(!environment.production) console.log("Not found");
        let base = "lock";
        this.IconGPS = base;
      }
    }
  }

  CheckAllowBloking(identifier: string) {
    this.setAllowedBloking(false);
    this.citronellaActionsService.getBlokingState(identifier).pipe(first()).subscribe({
      next: (data: EstatusJSON) => {
        if (data != null) {
          this.setAllowedBloking(data.isSuccess);
          this.setBlokingIcon(data.result.locked);
        }else{
          this.setAllowedBloking(false);
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al verificar estado de bloqueo', error);
        this.setAllowedBloking(false);
      }
    });
  }

  UpdateDetailLocation(Data: any) {
    //debe de llegar el idCategory primero, así que se pone el timeout
    if(!environment.production) console.log("category Data", Data);
    this.setCategorySelected( Data.idLocationCategory);
    setTimeout(() => {
      this.setVisibilityPopup(true);
      this.setLoading(true);
      this.setGeneralData(Data);
      this.setData(Data.data);
      this.routeFilterService.GetDirection(Data.cordsY, Data.cordsX).subscribe(direction => {
        this.setAddress(direction);
      });
      this.setLoading(false);
    }, 500);
  }


}
